var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 43,
    viewBox: "0 0 38 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M20.2275 39.0922C29.8764 39.0922 37.6984 31.2702 37.6984 21.6213C37.6984 11.9724 29.8764 4.15039 20.2275 4.15039C10.5786 4.15039 2.75659 11.9724 2.75659 21.6213C2.75659 31.2702 10.5786 39.0922 20.2275 39.0922Z",
    fill: "#9283BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9546 31.9573L27.7152 29.7977C27.3737 29.5692 26.9192 29.6138 26.6302 29.9054L23.5643 32.9714C21.7489 34.7868 19.563 36.1345 17.1907 36.9857L17.1986 37.0041L31.903 32.1149C31.6613 32.2437 31.325 32.2016 30.9572 31.9573H30.9546Z",
    stroke: "#4B3884",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.433 10.4688H27.1296V11.3305C27.1296 11.806 26.7434 12.1922 26.2679 12.1922H10.7726C10.2971 12.1922 9.91093 11.806 9.91093 11.3305V10.4688H5.60757C5.13205 10.4688 4.74585 10.8549 4.74585 11.3305V37.1559C4.74585 37.6314 5.13205 38.0176 5.60757 38.0176H11.3874C15.9535 38.0176 20.333 36.2048 23.5619 32.976L26.6278 29.91C26.9168 29.621 27.3713 29.5738 27.7128 29.8023L30.9522 31.9619C31.6878 32.4532 32.2894 32.13 32.2894 31.2447V11.3305C32.2894 10.8549 31.9032 10.4688 31.4277 10.4688H31.433Z",
    stroke: "#4B3884",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2943 7.02606H27.1293V11.3294C27.1293 11.8049 26.7431 12.1911 26.2676 12.1911H10.7723C10.2968 12.1911 9.9106 11.8049 9.9106 11.3294V7.02606H4.74553C2.84344 7.02606 1.30127 8.56823 1.30127 10.4703V38.0165C1.30127 39.9186 2.84344 41.4608 4.74553 41.4608H32.2917C34.1938 41.4608 35.736 39.9186 35.736 38.0165V10.4677C35.736 8.5656 34.1938 7.02344 32.2917 7.02344L32.2943 7.02606Z",
    stroke: "#4B3884",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4057 5.30335H22.8231C22.8231 2.92574 20.8974 1 18.5198 1C16.1422 1 14.2164 2.92574 14.2164 5.30335H11.6339C10.6829 5.30335 9.91309 6.07312 9.91309 7.02417V11.3275C9.91309 11.803 10.2993 12.1892 10.7748 12.1892H26.27C26.7456 12.1892 27.1318 11.803 27.1318 11.3275V7.02417C27.1318 6.07312 26.362 5.30335 25.4109 5.30335H25.4057Z",
    stroke: "#4B3884",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7993 5.30273H20.241",
    stroke: "#4B3884",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9009 15.4033C15.7695 15.3823 15.6329 15.3797 15.4963 15.3928C14.3745 15.5084 13.5837 16.7773 13.7282 18.2275C13.8543 19.4991 14.6609 20.4896 15.6145 20.6314C15.7459 20.6525 15.8825 20.6551 16.0191 20.6419C17.1409 20.5263 17.9317 19.2574 17.7872 17.8072C17.6611 16.5356 16.8546 15.5452 15.9009 15.4033Z",
    stroke: "#9283BD",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6867 19.1938C11.4896 19.1517 11.2873 19.1465 11.085 19.1806C10.0368 19.3672 9.39575 20.6019 9.65059 21.9418C9.85814 23.0242 10.5885 23.8413 11.4134 24.0173C11.6105 24.0593 11.8128 24.0646 12.0151 24.0304C13.0633 23.8439 13.7044 22.6091 13.4495 21.2692C13.242 20.1868 12.5116 19.3698 11.6867 19.1938Z",
    stroke: "#9283BD",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1392 15.4033C21.2706 15.3823 21.4072 15.3797 21.5438 15.3928C22.6656 15.5084 23.4564 16.7773 23.3119 18.2275C23.1858 19.4991 22.3792 20.4896 21.4256 20.6314C21.2942 20.6525 21.1576 20.6551 21.021 20.6419C19.8992 20.5263 19.1084 19.2574 19.2529 17.8072C19.379 16.5356 20.1855 15.5452 21.1392 15.4033Z",
    stroke: "#9283BD",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3534 19.1938C25.5504 19.1517 25.7527 19.1465 25.955 19.1806C27.0033 19.3672 27.6443 20.6019 27.3895 21.9418C27.1819 23.0242 26.4516 23.8413 25.6266 24.0173C25.4296 24.0593 25.2273 24.0646 25.025 24.0304C23.9767 23.8439 23.3357 22.6091 23.5905 21.2692C23.7981 20.1868 24.5284 19.3698 25.3534 19.1938Z",
    stroke: "#9283BD",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5203 21.5762C18.5203 21.5762 14.6294 23.6648 13.5181 26.4312H14.0566V28.7931H16.4185V30.661C17.3301 30.5402 18.0973 29.9806 18.5203 29.2029C18.9984 30.083 19.9206 30.6873 20.9925 30.6873C22.553 30.6873 23.8167 29.4236 23.8167 27.8631C23.8167 24.4188 18.5203 21.5762 18.5203 21.5762Z",
    stroke: "#9283BD",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85986 28.7935H11.2217V26.4316H14.0565V28.7935H16.4183V31.6282H14.0565V33.9901H11.2217V31.6282H8.85986V28.7935Z",
    stroke: "#4B3884",
    strokeWidth: 1.30309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.7840b864f8d5387b0bb78101128608b3.svg";
export { ForwardRef as ReactComponent };